<template>
  <div class="layout">
    <headerVue></headerVue>
    <div class="main-box">
      <div class="side-box">
        <div class="user-box" v-if="userInfo" @click="toSet()">
          <img v-if="userInfo.avatar" :src="userInfo.avatar" alt="" />
          <img v-else :src="require('@/assets/images/avatar.png')" alt="" />
          <span class="user-name">{{ userInfo.nickname }}</span>
          <span class="user-id">UID: {{ userInfo.uid }}</span>
        </div>
        <el-menu :default-openeds="openList" class="el-menu-vertical-demo" @open="handleOpen" @close="handleClose">
          <div v-for="(item, index) in menuList" :key="index">
            <el-submenu :index="`${index}`" v-if="item.children && item.children.length">
              <template slot="title">
                <div class="custom-menu-item" :class="{ active: currentPath.indexOf(item.path) >= 0 }" @click.stop="toTiku">
                  <img :src="getIconUrl(item.icon, currentPath.indexOf(item.path) >= 0)" alt="" />
                  <span>{{ item.name }}</span>
                </div>
              </template>
              <el-menu-item :index="`${index}-${i}`" v-for="(d, i) in item.children" :key="`${index}-${i}`">
                <router-link class="custom-menu-item sub" :to="d.path" :class="{ active: currentPath.indexOf(d.path) >= 0 }">
                  <img src="@/assets/images/sub-menu-icon.png" alt="" />
                  <span>{{ d.name }}</span>
                </router-link>
              </el-menu-item>
            </el-submenu>
            <el-menu-item :index="`${index}`" v-else>
              <router-link class="custom-menu-item" :to="item.path" :class="{ active: currentPath.indexOf(item.path) >= 0 }">
                <img :src="getIconUrl(item.icon, currentPath.indexOf(item.path) >= 0)" alt="" />
                <span>{{ item.name }}</span>
              </router-link>
            </el-menu-item>
          </div>
        </el-menu>
      </div>
      <div class="main-content">
        <router-view>
          <!-- 主要内容区域 -->
        </router-view>
      </div>
    </div>
    <footerVue></footerVue>
  </div>
</template>

<script>
import headerVue from "./header.vue";
import footerVue from "./footer.vue";
import { mapState } from "vuex";
export default {
  components: {
    headerVue,
    footerVue,
  },
  data() {
    return {
      menuList: [
        {
          name: "学习打卡",
          path: "/in/clockin",
          icon: "study",
        },
        {
          name: "财富专栏",
          path: "/in/wealthcolumn",
          icon: "wealth",
        },
        {
          name: "讨论区",
          path: "/in/discussion",
          icon: "discussion",
        },
        {
          name: "投资工具",
          path: "/in/investtool",
          icon: "invest",
        },
        {
          name: "我的",
          icon: "me",
          path: "/in/me",
          children: [
            {
              name: "知识题库",
              path: "/in/me/knowledgebase",
            },
            {
              name: "积分管理",
              path: "/in/me/scoremanage",
            },
            {
              name: "梦想工具",
              path: "/in/me/dreamtool",
            },
            {
              name: "设置",
              path: "/in/me/set",
            },
          ],
        },
      ],
      currentPath: "",
      // userInfo: {},
    };
  },
  computed: {
    ...mapState(["userInfo"]),
    openList() {
      let result = [];
      for (let i = 0; i < this.menuList.length; i++) {
        if (this.menuList[i].children) {
          result.push(`${i}`);
        }
      }
      return result;
    },
  },
  watch: {
    $route(val) {
      this.currentPath = val.path;
    },
  },
  mounted() {
    this.currentPath = this.$route.path;
    // this.userInfo = JSON.parse(localStorage.getItem(this.$constants.LOGIN_USER_INFO) || "{}");
  },
  methods: {
    toTiku() {
      this.$router.push("/in/me/knowledgebase");
    },
    toSet() {
      this.$router.push("/in/me/set");
    },
    getIconUrl(icon, active) {
      return require(`@/assets/images/menu-icon-${icon}${active ? "-act" : ""}.png`);
    },
    handleOpen(key, keyPath) {
      console.log(key, keyPath);
    },
    handleClose(key, keyPath) {
      console.log(key, keyPath);
    },
  },
};
</script>

<style lang="scss" scoped>
.layout {
  // width: 1440px;
  display: flex;
  flex-direction: column;
  align-items: center;
  min-height: 100vh; /* 确保至少占满整个屏幕高度 */
  position: relative;
  // &::before {
  //     width: 100%;
  //     content: '';
  //     position: absolute;
  //     height: 1px;
  //     background: rgba(0, 0, 0, 0.2);
  //     left: 50%;
  //     transform: translateX(-50%);
  //     top: 56px;

  //   }
}

::v-deep .el-submenu[disabled] .custom-menu-item {
  cursor: pointer !important;
}

.main-box {
  display: flex;
  padding: 24px 0 0;
  width: 1120px;
  margin: 0px auto;
  min-height: calc(100vh - 300px);
  // flex: 1;
  .side-box {
    width: 160px;
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    margin-right: 32px;

    .user-box {
      width: 160px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      padding: 0 0 20px 0;
      border-bottom: 0.5px solid rgba(0, 0, 0, 0.1);
      cursor: pointer;

      img {
        width: 48px;
        height: 48px;
        border-radius: 10px;
      }

      .user-name {
        font-weight: bold;
        margin-top: 15px;
      }

      .user-id {
        color: rgba(#000000, 0.6);
      }
    }

    ::v-deep .el-menu {
      border-right: none;
    }

    ::v-deep .el-menu-item {
      padding: 0px !important;
      height: initial;
      width: 160px;
      min-width: initial;
      opacity: 1;
    }

    ::v-deep .el-submenu {
      .el-submenu__title {
        padding: 0px !important;
        opacity: 1;
        height: initial;
        width: 160px;

        .el-submenu__icon-arrow {
          display: none;
        }
      }
    }

    .custom-menu-item {
      width: 160px;
      height: 40px;
      display: flex;
      align-items: center;
      text-decoration: none;
      padding-left: 33px;
      box-sizing: border-box;
      margin-top: 10px;

      img {
        width: 20px;
        height: 20px;
        margin-right: 10px;
      }

      span {
        color: #000000;
      }

      &.active {
        span {
          font-weight: bold;
          color: #cf0f0f;
        }
      }

      &:not(.sub) {
        &.active {
          position: relative;

          &::before {
            content: "";
            position: absolute;
            top: 50%;
            transform: translateY(-50%);
            left: 0px;
            width: 4px;
            height: 24px;
            background: #cf0f0f;
            border-radius: 2px;
          }
        }
      }

      &.sub {
        img {
          width: 12px;
          height: 12px;
          margin-right: 15px;
        }
      }
    }
  }

  .main-content {
    flex: 1;
    width: 950px;
    max-width: 950px;
    // overflow: hidden;
  }
}
</style>
